if (!customElements.get('cirelia-loop-video')) {
  customElements.define('cirelia-loop-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.start = () => {
        if (!this.visible || document.hidden) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.controls = false;
        this.video.loop = true;
        this.video.playsInline = true;
        this.video.play().catch(() => {});
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start();
        else this.video.pause();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.video.addEventListener('loadeddata', this.start, options);
      document.addEventListener('visibilitychange', this.start, options);
      window.addEventListener('pageshow', this.start, options);
      document.addEventListener('touchstart', this.start, { ...options, passive: true });
      document.addEventListener('pointerdown', this.start, options);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
    }
  });
}
